import Link from '../elements/link'
import './titleIntro.scss'

export default function TitleIntro({ headline, text, label, link, type }) {
  const linkExists = !!(link.link || link.kind || link.id)
  return (
    <div className={`title-intro ${type}`}>
      <div className="inner">
        {headline}
        <div className="text">{text}</div>
        {linkExists && label && (
          <div className="segoe">
            {linkExists && (
              <Link {...link} type={link.link_type}>
                <a>{label}</a>
              </Link>
            )}
            {!linkExists && label}
          </div>
        )}
        {!linkExists && label && <div className="segoe">{label}</div>}
      </div>
    </div>
  )
}
